import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Home, Phone, Calendar } from "lucide-react";

const ThankYouPage = () => {
  useEffect(() => {
    document.title = "Thank You | Mayker Financial Group";
    
    // Fire Google Ads conversion event when this page loads
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17728225776/xq77CKjX_eIbEPCDvYVC'
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F3] flex items-center justify-center px-4 pt-16" data-testid="thank-you-page">
      <div className="text-center max-w-lg">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-[#C9A84C]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-[#C9A84C]" />
        </div>
        
        {/* Heading */}
        <h1 className="font-playfair text-3xl lg:text-4xl font-bold text-[#0C1B33] mb-4">
          Thanks for reaching out!
        </h1>
        
        {/* Message */}
        <p className="text-lg text-[#6B7A99] mb-2 leading-relaxed">
          We've received your message.
        </p>
        <p className="text-[#6B7A99] mb-8 leading-relaxed">
          One of our advisors will be in touch within <strong className="text-[#0C1B33]">1 business day</strong>.
        </p>
        
        {/* Book a call CTA */}
        <div className="bg-white border border-[#DDD8CC] rounded-lg p-6 mb-6">
          <p className="text-sm text-[#6B7A99] mb-4">
            Want to skip the wait? Book a time that works for you:
          </p>
          <a 
            href="https://www.maykerfinancial.com/book-online"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#C9A84C] text-[#0C1B33] text-sm font-medium py-3 px-6 rounded hover:bg-[#E8CC80] transition-colors"
          >
            <Calendar className="w-4 h-4" />
            Book Your Free 15-Min Call
          </a>
        </div>
        
        {/* Secondary actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#0C1B33] hover:text-[#C9A84C] transition-colors"
          >
            <Home className="w-4 h-4" />
            Back to Homepage
          </Link>
          <span className="hidden sm:inline text-[#DDD8CC]">|</span>
          <a 
            href="tel:7788361962"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#0C1B33] hover:text-[#C9A84C] transition-colors"
          >
            <Phone className="w-4 h-4" />
            Call 778-836-1962
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
